import React, { memo } from "react";
import useAppStepper from "./index.hooks";
import { IconButton, MobileStepper } from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

type AppStepperProps = {
  steps: number;
  activeStep: number;
  stepChanger: (s: number) => void;
  stepStartComp?: React.ReactNode;
  stepFinalComp?: React.ReactNode;
  position: "top" | "bottom" | "static";
  isLoading?: boolean;
};

const AppStepper = ({
  steps,
  activeStep,
  stepChanger,
  stepStartComp,
  stepFinalComp,
  position,
  isLoading,
}: AppStepperProps) => {
  const { styles, classes, atomicStyles } = useAppStepper();

  return (
    <MobileStepper
      className={styles.fitContainer}
      position={position}
      variant={"dots"}
      steps={steps}
      activeStep={activeStep}
      backButton={
        <div className={styles.backComp}>
          {activeStep === 0 ? (
            stepStartComp
          ) : (
            <IconButton
              style={{
                background: "#673368",
              }}
              onClick={() => stepChanger(activeStep - 1)}
              disabled={isLoading}
            >
              <ChevronLeftIcon style={{ color: "white" }} />
            </IconButton>
          )}
        </div>
      }
      nextButton={
        <div className={styles.nextComp}>
          {activeStep === steps - 1 ? (
            stepFinalComp
          ) : (
            <IconButton
              style={{
                background: "#673368",
              }}
              onClick={() => stepChanger(activeStep + 1)}
              disabled={isLoading}
            >
              <ChevronRightIcon style={{ color: "white" }} />
            </IconButton>
          )}
        </div>
      }
    />
  );
};

export default memo(AppStepper);
